import { Checkbox } from 'element-ui'

const YCheckbox = Checkbox
YCheckbox.$depends = [Checkbox]
YCheckbox.$name = 'y-checkbox'
YCheckbox._name = 'Checkbox 复选框'

export default YCheckbox
